import { render, staticRenderFns } from "./MontageTeamsSection.vue?vue&type=template&id=7277a4fa&scoped=true"
import script from "./MontageTeamsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MontageTeamsSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MontageTeamsSection.vue?vue&type=style&index=0&id=7277a4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7277a4fa",
  null
  
)

export default component.exports